<template>
    <div>
        <div v-if="isObjective || isKeyResult" v-html="post.comment.content" class="comment"></div>
        <span v-else>
            {{ post.comment.content }}
        </span>
    </div>
</template>

<script>
import { artifactTypeMixin } from '@/mixins'

export default {
    name: 'PostComment',
    props: {
        post: {
            type: Object,
            required: true,
        },
    },
    mixins: [artifactTypeMixin],
}
</script>

<style scoped>
.comment ::v-deep p {
    margin: 0;
}
</style>
